export const GATES = {
  GPT_SIGNUP_REDIRECTION: 'GPT-SIGNUP-REDIRECTION'
};